import React, { useEffect, useState } from 'react';
import { useMagicLink as processMagicLink } from '../../util/api';
import CardPadding from '../lib/ui/CardPadding';
import Card from '../lib/ui/Card';
import CardLoadingSpinner from '../lib/ui/CardLoadingSpinner';
import LinkButton from '../lib/forms/simple/LinkButton.js';
import ButtonArea from '../lib/forms/ButtonArea';
import headerForeground from '../../assets/competentiemonitor/header/header-foreground-paths-login.svg';
import * as Sentry from '@sentry/browser';

export default function createUseMagicLink(refreshUser) {
	return function UseMagicLink({ match }) {
		const [ expiredToken, setExpiredToken ] = useState(false);
		const { token } = match.params;

		useEffect(() => {
			processMagicLink(token)
				.catch(async e => {
					// Extract error details for better logging
					let errorDetails = {};
					let responseBody = null;

					if (e instanceof Response) {
						errorDetails = {
							status: e.status,
							statusText: e.statusText,
							url: e.url,
							type: e.type,
						};

						// Try to extract response body
						try {
							const clonedResponse = e.clone();
							responseBody = await clonedResponse.json();
							errorDetails.responseBody = responseBody;
						} catch (jsonError) {
							// If JSON parsing fails, try as text
							try {
								const clonedResponse = e.clone();
								responseBody = await clonedResponse.text();
								errorDetails.responseBody = responseBody;
							} catch (textError) {
								errorDetails.responseBody = 'Could not parse response body';
							}
						}
					}

					// Create a more informative error for Sentry
					const sentryError = new Error(`Magic link processing failed: ${errorDetails.statusText || 'Unknown error'}`);
					sentryError.extra = {
						...errorDetails,
						token: token.substring(0, 8) + '...', // Only log partial token for security
						timestamp: new Date().toISOString(),
					};

					Sentry.captureException(sentryError, { extra: sentryError.extra });
					setExpiredToken(true);
				})
				.finally(refreshUser);
		}, [ token ]);

		return <div className="login">
			<Card>
				<div style={{ padding: 'var(--u-24) var(--u-32) 0 var(--u-32)' }}>
					<img
						style={{ paddingTop: 'var(--u-16)', maxWidth: '100%' }}
						className="logo"
						src={headerForeground}
						alt="Logo Competentiemonitor" />
				</div>
				<CardPadding>
					{!expiredToken && <CardLoadingSpinner/>}
					{expiredToken && <div>
                        De eenmalige link is verlopen. Log alsjeblieft nogmaals in.
						<br /><br />
						<ButtonArea>
							<LinkButton label="Naar inloggen" to="/magiclink" icon="angle-right" iconRight={true} />
						</ButtonArea>
					</div>}
				</CardPadding>
			</Card>;
		</div>;
	};
}
